import type { MathflatApi as ExamApi } from '@mathflat/domain/@entities/StudentExam/api'
import type { Entity as StudentWorksheetEntity } from '@mathflat/domain/@entities/StudentWorksheet/dto'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import type { AssignedStudentExam } from '~/@pages/student-worksheet/@common/types'

import maxios from '../utils/maxios'

export const studentExamApi = (() => {
  return {
    getStudentExams: ({
      studentId,
      dateTime: { startDate, endDate },
    }: {
      studentId: string
      dateTime: {
        startDate: string
        endDate: string
      }
    }) => {
      return maxios.get<
        DefaultResponse<(AssignedStudentExam & StudentWorksheetEntity.StudentWorksheet)[]>
      >(`/student-exam?studentId=${studentId}&startDate=${startDate}&endDate=${endDate}`)
    },
    getStudentExam: (studentExamId: string) => {
      return maxios.get<DefaultResponse<ExamApi.Response.StudentExamScoring>>(
        `/student-exam/${studentExamId}`,
      )
    },
    getStudentExamWithProblems: (studentExamId: string) => {
      return maxios.get<DefaultResponse<ExamApi.Response.ExamProblem[]>>(
        `/exam/${studentExamId}/problem`,
      )
    },

    patchStudentExamAutoScoringById: (
      studentExamId: string,
      scoringList: ExamApi.Request.StudentExamAutoScoring[],
    ) => {
      return maxios.patch(`/student-exam/${studentExamId}/auto-scoring`, scoringList, {
        params: {
          version: 'v2',
        },
      })
    },

    postStudentExamSolve: (studentExamId: string) => {
      return maxios.post(`/student-exam/${studentExamId}/solve`)
    },
  }
})()
